import useDepartmentUiMode from 'model/useDepartmentUiMode';
import {
  CurrentDepartmentTextContext,
  DepartmentTerminologyContext,
  DepartmentText,
  objectText,
  strediskoText,
} from 'model/DepartmentTerminology';
import { ReactNode, useCallback, useLayoutEffect, useRef } from 'react';

/** Resolves terminology once for the effective authenticated viewer, across all UI surfaces. */
export function DepartmentTerminologyProvider({ children }: { children: ReactNode }) {
  const { mode } = useDepartmentUiMode();
  const text = mode === 'legacy' ? strediskoText : objectText;
  const currentText = useRef(text);
  useLayoutEffect(() => {
    currentText.current = text;
    return () => {
      currentText.current = objectText;
    };
  }, [text]);
  const getCurrentText = useCallback<DepartmentText>(
    (objectLabel, departmentLabel) => currentText.current(objectLabel, departmentLabel),
    []
  );

  return (
    <CurrentDepartmentTextContext.Provider value={getCurrentText}>
      <DepartmentTerminologyContext.Provider value={text}>{children}</DepartmentTerminologyContext.Provider>
    </CurrentDepartmentTextContext.Provider>
  );
}
